// Routes
import './routes';

// Auth handler
import authHandler from './utils/auth-handler';
Vue.use(authHandler);

// Workspace handler
import workspaceHandler from './utils/workspace-handler';
Vue.use(workspaceHandler);

// Interface handler
import userInterfaceHandler from './utils/user-interface-handler';
Vue.use(userInterfaceHandler);

// Dark mode handler
import darkModeHandler from './utils/dark-mode-handler';
Vue.use(darkModeHandler);

// Components
import './components/form/CmsLoginForm';
import './components/form/CmsPasswordRecoveryForm';
import './components/form/CmsPasswordResetForm';
import './components/form/controls/CmsMediaControl.js';
import './components/form/controls/CmsLinkControl.js';
import './components/form/controls/CmsRouteMappingMatrix.js';
import './components/form/controls/CmsSlugControl.js';

// share
import './components/share/CmsShareMenuItem.js';
import './components/share/CmsShareModal.js';

// share
import './components/preview/CmsPublicationPreviewItem';

// media
import './components/media/CmsMediaCard.js';
import './components/media/CmsMediaRelationResolver.js';
import './components/media/CmsMediaInspector.js';
import './components/media/CmsMediaRelationDataTable.js';
import './components/media/CmsFocalPointEditor.js';

// published
import './components/published/CmsPublishedToggle.js';

// QR code 2FA
import './components/form/widget/QRCode2FA.js';

// account
import './components/account/CmsAccountMenu';
import './components/account/CmsProfile';
import './components/account/CmsSetHomepage';
import './components/account/CmsDarkModeControl';
import './components/account/CmsWelcome';

// Inbox
import './components/inbox/CmsInboxDetail';

// layout
import './components/layout/CmsActiveWorkspace';
import './components/layout/CmsActiveWorkspaceLogo';
import './components/layout/CmsSettingsMenu';

// Seo
import './components/seo/CmsSeoPreview';

// Page
import './components/pages/CmsForm';
import './components/pages/CmsGrid';
import './components/pages/CmsList';
import './components/pages/CmsPageNotFound';
import './components/pages/CmsDashboard';
import './components/pages/CmsPasswordResetExpired';
import './components/pages/CmsHistory';

// Grid
import './components/grid/CmsAutoSaveBadge.js';

// Redactor plugins
import './utils/redactor-plugins/link-to';
